__turbopack_context__.v({
  "Body": "ikCG0G_Body",
  "Card": "ikCG0G_Card",
  "CardWrapper": "ikCG0G_CardWrapper",
  "CardWrapper--Pinned": "ikCG0G_CardWrapper--Pinned",
  "Content": "ikCG0G_Content",
  "Footer": "ikCG0G_Footer",
  "Header": "ikCG0G_Header",
  "HeaderText": "ikCG0G_HeaderText",
  "IconBadge": "ikCG0G_IconBadge",
  "IconGlyph": "ikCG0G_IconGlyph",
  "Label": "ikCG0G_Label",
  "Location": "ikCG0G_Location",
  "Source": "ikCG0G_Source",
  "SourceList": "ikCG0G_SourceList",
  "Sources": "ikCG0G_Sources",
  "SourcesLabel": "ikCG0G_SourcesLabel",
  "Title": "ikCG0G_Title",
  "material-symbols-outlined": "ikCG0G_material-symbols-outlined",
  "material-symbols-rounded": "ikCG0G_material-symbols-rounded",
  "material-symbols-sharp": "ikCG0G_material-symbols-sharp",
  "skeleton-loading": "ikCG0G_skeleton-loading",
});
